export const SET_NEW_FILE = 'fileUploadComponent.setNewFile'
export const SET_IN_PROGRESS = 'fileUploadComponent.setInProgress'
export const SET_ERROR = 'fileUploadComponent.setError'

export function setNewFile(payload: any) {
  return {
    type: SET_NEW_FILE,
    payload
  } as const
}

export function setInProgress(payload: any) {
  return {
    type: SET_IN_PROGRESS,
    payload
  } as const
}

export function setError(error: string) {
  return {
    type: SET_ERROR,
    payload: error
  } as const
}

export type FileUploadAction = ReturnType<typeof setNewFile | typeof setInProgress | typeof setError>
